<template>
    <div class="system-photos-page">
        <systemphotos
            :isshow="true"
            :embedded="true"
            :selectable="false"
            phototype="system"
            dialogTitle="系统图集"
        />
    </div>
</template>

<script>
import systemphotos from '@/components/systemphotos/index';

export default {
    name: 'SystemPhotos',
    components: {
        systemphotos,
    },
    methods: {
        OnloadMethod() {},
        BrotherComponentIn() {},
        freshdata() {},
    },
};
</script>

<style scoped>
.system-photos-page {
    width: 100%;
    min-height: 620px;
}
</style>
